import _ from "lodash";
import { queryBuilder } from "@lbs/swarm-client";

import { ISwarmRequestParams } from "../models/request";
import { ISwarmHotKeyModel } from "../models/response";

export const getFromGameToEventsByIdsSwarmQuery = (eventIds: number[]): ISwarmRequestParams => {
  const builder = queryBuilder()
    .useSource("betting")
    .selectGame(["id", "team1_name", "team2_name"])
    .selectMarket(["name", "title", "type", "market_type"])
    .selectEvent(["id", "name", "type", "price"])
    .whereEvent("id")
    .in(eventIds);

  return builder.getParams();
};

export const getGameAllMarketsSwarmQuery = (
  gameId: number,
  marketType: string,
  eventType: string
): ISwarmRequestParams => {
  const builder = queryBuilder()
    .useSource("betting")
    .selectMarket(["id", "name", "market_type", "display_key", "base", "express_id"])
    .selectEvent(["id", "name", "price", "type", 'base'])
    .whereGame("id")
    .is(gameId)
    .whereMarket("market_type")
    .is(marketType)
    .whereEvent("type")
    .is(eventType);

  return builder.getParams();
};

export const getGameMarketEventByIdSwarmQuery = (gameId: number, marketId: number, eventId: number) => {
  const builder = queryBuilder()
    .useSource("betting")
    .selectGame(["team1_name", "team2_name", "is_blocked", "is_live", "#sport:id", "#sport:alias", "type"])
    .selectMarket(["name", "display_key", "express_id"])
    .selectEvent(["price", "name", "base", "type", "home_value", "away_value"])
    .whereGame("id")
    .is(gameId)
    .whereMarket("id")
    .is(marketId)
    .whereEvent("id")
    .is(eventId);

  return builder.getParams();
};

export const getHotKeyGameDetailsSwarmQuery = (gameNumber: number, hotKeyModel: ISwarmHotKeyModel) => {
  const builder = queryBuilder()
    .useSource("betting")
    .selectGame(["team1_name", "team2_name", "is_blocked", "is_live", "#sport:id", "#sport:alias", "type", "id", "game_number"])
    .selectMarket(["name", "display_key", 'market_type', "id", "express_id"])
    .selectEvent(["price", "name", "base", "type", "id", "type_id", "home_value", "away_value"])
    .whereGame("game_number")
    .is(gameNumber)
    .whereSport("id")
    .is(hotKeyModel.SportId)
    .whereMarket("market_type")
    .is(hotKeyModel.MarketType)
    .whereEvent("type_id")
    .is(hotKeyModel.SelectionTypeId);

  if (!_.isNil(hotKeyModel.Handicap)) {
    builder.whereEvent('base').is(hotKeyModel.Handicap);
  }

  if (!_.isNil(hotKeyModel.HomeValue)) {
    builder.whereEvent('home_value').is(+hotKeyModel.HomeValue);
  }

  if (!_.isNil(hotKeyModel.AwayValue)) {
    builder.whereEvent('away_value').is(+hotKeyModel.AwayValue);
  }

  return builder.getParams();
}